import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux'
import store from './redux/store'
import "./index.css"
import { IntercomProvider } from 'react-use-intercom';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community'; 
import { LicenseInfo } from '@mui/x-license-pro';

LicenseInfo.setLicenseKey('33e1e45a88f732ac2a9c8535c72b0d82Tz0xMTMyMzAsRT0xNzc5MzIxNTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=');

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

ModuleRegistry.registerModules([AllCommunityModule]);

root.render(
  <GoogleReCaptchaProvider reCaptchaKey="6LdZdDcmAAAAAMei-PWJcFveRdjq032Rf7mVxcxr">
    <IntercomProvider appId={'qslqstly'} autoBoot>
      <Provider store={store}>
        <App />
      </Provider>
    </ IntercomProvider>
  </GoogleReCaptchaProvider>
);
reportWebVitals();
